var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"block pl-5 pr-2 py-1 font-open-sans text-xl tracking-wide  transition duration-150 ease-in-out font-semibold uppercase",attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }